import { render, staticRenderFns } from "./Promotion_set_details.vue?vue&type=template&id=03cde1be&scoped=true&"
import script from "./Promotion_set_details.vue?vue&type=script&lang=js&"
export * from "./Promotion_set_details.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_set_details.vue?vue&type=style&index=0&id=03cde1be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cde1be",
  null
  
)

export default component.exports